<template>
  <article class="resource__container"
           :class="{ discard__resource: resourceLocale.attendance !== null && resourceLocale.attendance.isDiscarded }"
           @click.stop="onModalClick"
  >
    <section class="card__container">
      <div class="head">
        <div>
          <header :class="{ graduation__header: !resourceLocale.image }">
            <img :src="completedImg"
                 alt="Image avec une coche pour indiquer que la ressource est complétée"
                 class="completed__img"
                 :class="{ completed__img__display: resourceLocale.attendance !== null && resourceLocale.attendance.isCompleted }"
            />
            <img :src="resourceLocale.image"
                 alt="Image d'en-tête pour la ressource"
                 v-if="resourceLocale.image"
            />
            <img :src="JLearnImg"
                 alt="Chapeau de diplômé avec le bord carré"
                 class="graduation_hat"
                 v-else
            />
          </header>
          <section>
            <h2>{{ resourceLocale.title }}</h2>
          </section>
        </div>
        <footer>
          <ul>
            <li>
              <icon-moon :icon-class="resourceLocale.icon"/>
            </li>
            <li>{{ resourceLocale.duration }}</li>
          </ul>
          <svg @click.stop="onFlipClick">
            <path
              d="M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z"
              fill="white"></path>
          </svg>
        </footer>
      </div>

      <div class="face">
        <section>
          <h2>{{ resourceLocale.title }}</h2>
          <p v-html="resourceLocale.description"></p>
        </section>
        <footer>
          <ul>
            <li>
              <icon-moon :icon-class="resourceLocale.icon"/>
            </li>
            <li>{{ resourceLocale.duration }}</li>
          </ul>
          <svg @click.stop="onFlipClick">
            <path
              d="M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z"
              fill="white"></path>
          </svg>
        </footer>
      </div>
    </section>
  </article>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IconMoon from '@/components/appUser/results/resourcesIcons/IconMoon'

export default {
  name: 'Ressource',
  components: { IconMoon },
  props: {
    resourceId: {
      type: String,
      required: true
    },
    isMiniature: {
      type: Boolean,
      required: true
    },
    resourceType: {
      type: String,
      required: false,
      default: 'attend'
    }
  },
  data () {
    return {
      /**
       * @type {ResourceAir}
       */
      resourceLocale: {},
      /**
       * @type {ResourceAir}
       */
      resourceModale: {},
      JLearnImg: require('@/assets/img/app-jlearn96.png'),
      completedImg: require('@/assets/img/completed.png')
    }
  },
  computed: {
    ...mapGetters('Resources', [
      'resources',
      'resourcesDiscarded',
      'resourcesCompleted'
    ])
  },
  created () {
    this.resourceLocale = Object.assign(
      {},
      this.resourceType === 'attend'
        ? this.resources.find(resource => resource.id === this.resourceId)
        : this.resourceType === 'completed'
          ? this.resourcesCompleted.find(resource => resource.id === this.resourceId)
          : this.resourcesDiscarded.find(resource => resource.id === this.resourceId)
    )

    this.resourceModale = Object.assign({}, this.resourceLocale)

    if (this.isMiniature) {
      this.resourceLocale.description = this.resourceLocale.description.length > 100
        ? this.resourceLocale.description.substring(0, 97) + '...'
        : this.resourceLocale.description
    } else {
      this.resourceLocale.description = this.resourceLocale.description.length > 350
        ? this.resourceLocale.description.substring(0, 347) + '...'
        : this.resourceLocale.description
    }

    this.resourceLocale.duration = this.resourceLocale.duration.split(':')
      .map((value, index) => {
        const defHour = ['h', 'min', 's']
        return value !== '00'
          ? `${value} ${defHour[index]}`
          : ''
      })

    // Indiquer le temps raccourci si la ressource est en mode miniature
    this.isMiniature
      ? this.resourceLocale.duration = this.resourceLocale.duration.find(value => value !== '')
      : this.resourceLocale.duration = this.resourceLocale.duration.join(' ')
        .trim()
  },
  methods: {
    ...mapActions('Resources', [
      'displayResource'
    ]),
    onFlipClick () {
      this.$el.firstChild.classList.toggle('is__flipped')
    },
    onModalClick () {
      this.displayResource(this.resourceModale)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/colors";

  .resource__container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    position: relative;
    perspective: 600px;
    width: 100%;
    cursor: pointer;

    &.discard__resource {
      opacity: 0.5;
    }

    .card__container {
      border: 1px solid $borderCard;
      position: relative;
      transform-style: preserve-3d;
      transform-origin: center center;
      transition: transform 500ms;
      height: 100%;

      &.is__flipped {
        transform: rotateY(-180deg);
      }

      .head, .face {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        backface-visibility: hidden;

        header {
          width: 100%;
          margin-bottom: 10px;
          display: flex;
          justify-content: center;

          &.graduation__header {
            background-color: #293a48;
          }

          img {
            width: 100%;
            display: block
          }

          .graduation_hat {
            width: 50%;
            margin: 5px 0;
            background-color: #293a48;
          }

          .completed__img {
            width: 60px;
            position: absolute;
            top: 0;
            left: 0;
            display: none;

            &.completed__img__display {
              display: block;
            }
          }
        }

        section {
          padding: 0 16px 5px 16px;

          h2 {
            font-size: 24px;
            line-height: 1em;
            font-weight: normal;
            text-align: center;
          }

          p {
            font-size: 15px;
          }
        }

        footer {
          background-color: $backgroundColorFooter;
          display: flex;
          justify-content: space-between;
          align-items: center;

          ul {
            padding: 0;
            display: flex;
            align-items: center;
            margin: 0;

            li {
              color: white;
              list-style: none;
              border-right: 1px solid $borderItemFooter;
              padding: 0 6px;
              font-weight: normal;
              font-size: 14px;

              symbol {
                width: 16px;
                height: 16px;
              }
            }
          }

          svg {
            width: 16px;
            height: 16px;
            cursor: pointer;
            margin: 7px 8px 7px 0;
          }
        }
      }

      .face {
        transform: rotateY(180deg);
        background-color: #ffffff;

        section {
          padding-top: 16px;
        }

        h2 {
          margin-bottom: 16px;
        }
      }
    }
  }

  .miniature {
    .card__container {
      .head, .face {
        section {
          padding: 5px;

          h2 {
            font-size: 15px;
            margin-bottom: 5px;
          }

          p::v-deep {
            font-size: 12px;

            .wysiwyg {
              h1, h2, h3, h4, h5, h6 {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
</style>
